import './style/home.css'
import BarcodeScannerComponent from "./barcodeScanner";
import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {alert} from "mdui";


export default function Home() {
    const navigate = useNavigate()
    const [isScanning, setIsScanning] = useState(false)
    const [data, setData] = useState("")
    const inputRef = useRef()
    useEffect(() => {
        inputRef.current.addEventListener("change", (e) => {
            setData(e.target.value)
        })
    }, []);
    return <>
        <div className={"container"}>
            <p style={{textAlign: "center"}}>灵狐序列号查询</p>
            {isScanning && <BarcodeScannerComponent
                width={"auto"}
                height={"auto"}
                onUpdate={(err, result) => {
                    if (result) {
                        setData(result.text.slice(0, -1))
                        setIsScanning(false)
                    }
                }}
            />
            }
            <mdui-text-field label="序列号" variant={"outlined"} value={data} ref={inputRef}>
                <mdui-button slot={"end-icon"} variant={"tonal"} style={{fontSize: "14px"}} onClick={() => {
                    setIsScanning(true)
                }}>扫码填充
                </mdui-button>
            </mdui-text-field>
            <mdui-button onClick={() => {
                navigate("/query/" + data)
            }}>查询
            </mdui-button>
        </div>
    </>
}

export function Query() {
    let {sn} = useParams()
    const navigate = useNavigate()
    const [data, setData] = useState({
        name: "",
        specification: "",
        description: "",
        manufacturer: ""
    })
    useEffect(() => {
        fetch(`/api/query/${sn}/`).then(res => res.json()).then(data => {
            if (data.status === "success") {
                setData({
                    name: data.data.name,
                    specification: data.data.specification,
                    description: data.data.description,
                    manufacturer: data.data.manufacturer
                })
            }else{
                alert({
                    headline: "错误",
                    description: "未找到该序列号，请重试",
                    confirmText: "确定",
                    onConfirm: () => {
                        navigate("/")
                    }
                })
            }
        })
    }, [])
    return <>
        <div className={"container"}>
            <p style={{textAlign: "center"}}>灵狐序列号查询</p>
            <span>序列号: {sn}</span>
            {data.name !== "" && <>
                <span>产品名称: {data.name}</span>
                <span>产品规格: {data.specification}</span>
                <span>产品描述: {data.description}</span>
                <span>生产企业: {data.manufacturer}</span>
            </>}
        </div>
    </>
}